import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-315372b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "D-Flex FlexColumn",
  style: {"padding":"0.3em","gap":"0.5em"}
}
const _hoisted_2 = {
  key: 0,
  class: "F1_25em color3"
}
const _hoisted_3 = {
  key: 1,
  class: "D-Flex W-100"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "D-Flex P-Abs BG2Fixed Shadow3",
  style: {"left":"0","right":"0","bottom":"0","height":"8em","margin-bottom":"1em","z-index":"10","overflow":"hidden"}
}
const _hoisted_6 = {
  class: "M-Auto D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_7 = {
  key: 1,
  class: "D-Flex P-Abs Inset0 BG4",
  style: {"justify-content":"center","align-items":"center","z-index":"40"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesRadioButton = _resolveComponent("CookiesRadioButton")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesSlider = _resolveComponent("CookiesSlider")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "AdminUIPanel D-Flex",
    style: _normalizeStyle([{"backdrop-filter":"blur(10px)"}, [_ctx.Opened ? 'width: 25vw;' : 'width: 0; min-width: 0;', 'background: ' + _ctx.Theme.Light2]])
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Clicked && _ctx.Clicked(...args))),
      class: "AdminUIPanelBodyExpander BGMain D-Flex Shadow1 HoverGlow"
    }, [
      _createVNode(_component_CookiesIcon, {
        class: "M-Auto W-75",
        style: _normalizeStyle(_ctx.Opened ? 'rotate: -90deg; margin-inline-end: 0.2em;' : 'rotate: 90deg; margin-inline-start: 0.2em;'),
        Color: (_ctx.Theme.BG2 as IconColor),
        ID: ('SortingArrow' as IconsIDs)
      }, null, 8, ["style", "Color", "ID"])
    ]),
    _createElementVNode("div", {
      class: "AdminUIPanelBody H-Auto",
      style: _normalizeStyle([_ctx.Opened ? '' : 'opacity: 0;', {"padding-bottom":"14em"}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredGroups, (group, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("div", _hoisted_1, [
            (group.Title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.Translate(group.Title)), 1))
              : _createCommentVNode("", true),
            (group.RadioButtons && group.RadioButtons.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.RadioButtons, (RadioButton) => {
                    return (_openBlock(), _createBlock(_component_CookiesRadioButton, {
                      key: RadioButton.Res,
                      Res: RadioButton.Res,
                      Name: RadioButton.Name,
                      Disabled: RadioButton.Disabled,
                      Value: RadioButton.Value,
                      Default: RadioButton.Default
                    }, null, 8, ["Res", "Name", "Disabled", "Value", "Default"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Switches, (checkbox) => {
              return (_openBlock(), _createBlock(_component_CookiesCheckBox, {
                style: _normalizeStyle({ order: typeof checkbox.Order === 'number' ? checkbox.Order : '' }),
                key: checkbox.Res,
                Name: checkbox.Name,
                Type: checkbox.Type,
                Res: checkbox.Res,
                class: "P1em"
              }, null, 8, ["style", "Name", "Type", "Res"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.TextInputs, (textInput) => {
              return (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                style: _normalizeStyle({ order: typeof textInput.Order === 'number' ? textInput.Order : '' }),
                key: textInput.Res,
                Placeholder: textInput.Name,
                Res: textInput.Res
              }, null, 8, ["style", "Placeholder", "Res"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Sliders, (slider) => {
              return (_openBlock(), _createBlock(_component_CookiesSlider, {
                style: _normalizeStyle([{ order: typeof slider.Order === 'number' ? slider.Order : '' }, {"width":"90%"}]),
                class: "H-Auto",
                key: slider.Res,
                CookiesSettings: (slider as SliderComponent)
              }, null, 8, ["style", "CookiesSettings"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ImageSelectors, (imageSelector) => {
              return (_openBlock(), _createBlock(_component_CookiesImageInput, {
                style: _normalizeStyle([{ order: typeof imageSelector.Order === 'number' ? imageSelector.Order : '' }, {"border-radius":"var(--rad1)"}]),
                key: imageSelector.Res,
                Res: imageSelector.Res
              }, null, 8, ["style", "Res"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.Selectors, (DropDown) => {
              return (_openBlock(), _createBlock(_component_CookiesDropDown, {
                style: _normalizeStyle({ order: typeof DropDown.Order === 'number' ? DropDown.Order : '' }),
                key: DropDown.Res,
                Res: DropDown.Res,
                Options: DropDown.Options,
                Name: DropDown.Name,
                Type: DropDown.Selector ? 'Object' : 'String',
                Selector: DropDown.Selector,
                Radio: DropDown.Radio,
                Disabled: DropDown.Disabled
              }, null, 8, ["style", "Res", "Options", "Name", "Type", "Selector", "Radio", "Disabled"]))
            }), 128)),
            (group.Slot)
              ? _renderSlot(_ctx.$slots, group.Slot, { key: 2 }, undefined, true)
              : _createCommentVNode("", true)
          ]),
          _hoisted_4
        ], 64))
      }), 128))
    ], 4),
    (_ctx.FooterButtons && _ctx.FooterButtons.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.FooterButtons.indexOf('save') > -1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save'))),
                  class: "CookiesButton BGMain"
                }, _toDisplayString(_ctx.Translate('Save')), 1))
              : _createCommentVNode("", true),
            (_ctx.FooterButtons.indexOf('reset') > -1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reset'))),
                  class: "CookiesButton"
                }, _toDisplayString(_ctx.Translate('Reset')), 1))
              : _createCommentVNode("", true),
            (_ctx.FooterButtons.indexOf('close') > -1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
                  class: "CookiesButton BGRed"
                }, _toDisplayString(_ctx.Translate('close')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.Saving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_CookiesLoading, {
            class: "M-Auto",
            style: {"width":"10em","height":"4em"}
          })
        ]))
      : _createCommentVNode("", true)
  ], 4))
}